/** Stands in for a cell with no value, so an empty column still reads as a column. */
export const EM_DASH = '—';
